import { Theme } from '@mui/material/styles'

import { ThemeAction } from '../actions'
import { ThemeTypes } from '../actions/index.models'
import { defaultTheme, keys, themes } from '../themes'

export interface ThemeState {
  name: string
  values: Theme
  options: string[]
}

//temporary until we support multiple themes
const initialTheme = defaultTheme

export const defaultThemeState: ThemeState = {
  name: defaultTheme,
  values: themes[initialTheme],
  options: keys,
}

const themeReducer = (state: ThemeState = defaultThemeState, action: ThemeAction) => {
  switch (action.type) {
    case ThemeTypes.SWITCH_THEME: {
      const theme = action.theme
      return {
        name: theme,
        values: themes[theme],
        options: keys,
      }
    }
    default:
      return state
  }
}

export default themeReducer
